import { render, staticRenderFns } from "./Reimposta-password.vue?vue&type=template&id=2c279448&scoped=true&"
import script from "./Reimposta-password.vue?vue&type=script&lang=js&"
export * from "./Reimposta-password.vue?vue&type=script&lang=js&"
import style0 from "./Reimposta-password.vue?vue&type=style&index=0&id=2c279448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c279448",
  null
  
)

export default component.exports